import { Employee } from "domain/entities/employee";
import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface PeopleManagersState {
  peopleManagers: Parameter[];
  setPeopleManagers: (newPeopleManagers: Parameter[] | undefined) => void;
}

export const usePeopleManagersStore = create<PeopleManagersState>()(
  devtools(
    (set) => ({
      peopleManagers: [],
      setPeopleManagers: (newPeopleManagers) =>
        set(() => ({
          peopleManagers: newPeopleManagers ? [...newPeopleManagers] : [],
        })),
    }),
    { name: "PeopleManagersStore" }
  )
);
